<template>
   <div>
     <div class="search_unit">
        <div style='display:inline-block;'>
          <el-input placeholder="请输入搜索关键字" v-model="keywords" class="input-with-select" @change='getList()'>
                    <el-button slot="append" icon="el-icon-search" @click='getList()'></el-button>
          </el-input>
        </div>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%">
      <el-table-column
        label="缩略图">
      <template slot-scope="scope"> 
           <el-image
          style="width: 100px; height: 100px"
          :src="scope.row.headimg"
          fit="fit"></el-image>
      </template>
      </el-table-column>
      <el-table-column
        prop="id"
        label="ID"
        >
      </el-table-column>
      <el-table-column
        label="名称"
        >
        <template slot-scope="scope">
            <div>{{scope.row.name}}</div>
            <div>(直升{{scope.row.tolevelname}})</div>
        </template> 
      </el-table-column>
      <el-table-column
        prop="price" 
        label="价格">
      </el-table-column>
      <el-table-column
        label="包含商品"
        width="180" 
       >
        <template slot-scope="scope">
          <div v-for="item in scope.row.goodsdetail" :key="item.id">
               {{item.name}}x{{item.nums}}
          </div>
         </template>
      </el-table-column>
      <el-table-column
        prop="stock"
        label="库存">
      </el-table-column>
      <el-table-column
        label="状态">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.status==1">上线中</el-tag> <el-tag type="info" v-if="scope.row.status==0">已下线</el-tag> 
        </template>
      </el-table-column>
      <el-table-column
        label="创建时间">
        <template slot-scope="scope"> 
           {{scope.row.createtime | timeToDate}}    
        </template>
      </el-table-column>
      <el-table-column
        label="操作">
        <template slot-scope="scope"> 
             <el-dropdown split-button type="primary" @click='handleEdit(scope.row.id)' @command='(command)=>handleItem(command,scope.row.id)'>
              编辑
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command='online'>上线</el-dropdown-item>
                <el-dropdown-item command='offline'>下线</el-dropdown-item>
                <el-dropdown-item command='delete'>删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
      <div class='page-number'>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="pageinfo.total"
          :page-size="pageinfo.pagesize"
          :current-page.sync="pageinfo.pageindex"
          @current-change='getList'
          >
        </el-pagination>
      </div>
   </div> 
</template>

<script>
export default {
  data(){
     return {
        tableData:[],
        keywords:'',
        pageinfo:{
          total:0,
          pagesize:10,
          pageindex:1
        }
     }
  },
  created(){
     this.getList()
  },
  methods: {
      getList(){
          this.$post("/goods/getDGoodsList",{pageinfo:this.pageinfo,keywords:this.keywords}).then((data)=>{
               if(data.result.success){
                  this.tableData=data.result.info.goodslist
                  this.pageinfo=data.result.info.pageinfo 
               }else{
                  this.$message.error(data.result.info)
               }
          })
      },
      handleEdit(goodsid){
          this.$router.push({name:'adddgoods',query:{goodsid:goodsid}})
      },
      handleItem(command,goodsid){
        switch(command){
          case 'delete':
                this.$post("/goods/setDGoodsStatus",{goodsid:goodsid,status:99}).then((data)=>{
                  if(data.result.success){
                      this.$message({message:data.result.info,type:'success'})
                      setTimeout(()=>{this.getList()},300)
                  }else{
                      this.$message.error(data.result.info)
                  } 
                })
                break;
          case 'online':
                this.$post("/goods/setDGoodsStatus",{goodsid:goodsid,status:1}).then((data)=>{
                  if(data.result.success){
                      this.$message({message:data.result.info,type:'success'})
                      setTimeout(()=>{this.getList()},300)
                  }else{
                      this.$message.error(data.result.info)
                  } 
                })
               break;
          case 'offline':
               this.$post("/goods/setDGoodsStatus",{goodsid:goodsid,status:0}).then((data)=>{
                  if(data.result.success){
                      this.$message({message:data.result.info,type:'success'})
                      setTimeout(()=>{this.getList()},300)
                  }else{
                      this.$message.error(data.result.info)
                  } 
                })
               break;           
          default:
              this.$message.error("选项有误");  
              break;    
        }
      }
  }
}
</script>

<style scoped lang="scss">
.page-number{margin-top:20px;float:right;}
.search-unit{margin-top: 15px;}
</style>
